// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"a536eead","605":"73d9334c","786":"73d9334c","877":"73d9334c","933":"5bfd98e2"}[chunkId] + ".chunk.css";
};